/* eslint react/no-multi-comp: 0, react/prop-types: 0 */
// eslint-disable-next-line
import React, { Fragment, useState, useEffect } from 'react';
import { Row, Col } from 'reactstrap'; // eslint-disable-next-line
import avatar_img from '../../assets/img/team/avatar.svg'; // eslint-disable-next-line
import Badge from 'reactstrap/es/Badge'; // eslint-disable-next-line
import { copiriAxiosPost, copiriPortalRequest } from '../api/api'; // eslint-disable-next-line
import config from '../config/config'; // eslint-disable-next-line
import CopiriLoader from '../common/CopiriLoader'; // eslint-disable-next-line
import default_avatar from '../../assets/img/team/avatar.svg'; // eslint-disable-next-line
import UserDegreeHistroyAccordion from './accordion/UserDegreeHistroyAccordion';
import { copy } from './Common';
import { genPageData } from '../langconfig/langconfig'; // eslint-disable-next-line
const UserProfileAccountStatus = props => {
	// eslint-disable-next-line
	const { data, pageLanguageContent, profileId } = props;

	/* function to copy content*/
	function copyContent(content) {
		copy(content);
	}

	return (
		<fieldset className='border p-2'>
			<legend className='w-auto'>{pageLanguageContent['PRL180'] ? pageLanguageContent['PRL180'] : ''}</legend>
			<Row>
				<Col sm='12'>
					<span>
						<strong>{pageLanguageContent['PRL077'] ? pageLanguageContent['PRL077'] : ''}:</strong>
					</span>
					<span className='ml-2'>
						{!data['email_validated'] ? (
							<>{pageLanguageContent['PRL159'] ? pageLanguageContent['PRL159'] : ''}</>
						) : (
							<>{pageLanguageContent['PRL078'] ? pageLanguageContent['PRL078'] : ''}</>
						)}
					</span>
				</Col>
				<Col sm='10'>
					<span>
						<strong>{pageLanguageContent['PRL060'] ? pageLanguageContent['PRL060'] : ''}:</strong>
					</span>
					<span className='ml-2'>
						{!data?.emails && <> {pageLanguageContent['PRL166'] ? pageLanguageContent['PRL166'] : ''}</>}

						{data?.emails && data?.emails.length > 0 && (
							<>
								{data['emails']['0']['validated'] ? (
									<> {pageLanguageContent['PRL170'] ? pageLanguageContent['PRL170'] : ''}</>
								) : (
									<>
										{' '}
										<strong>
											<span style={{ color: '#f5803e' }}>
												{data['emails']['0']['code'] ? data['emails']['0']['code'] : ''}
											</span>
										</strong>{' '}
										({pageLanguageContent['PRL171'] ? pageLanguageContent['PRL171'] : ''}{' '}
										<strong>{pageLanguageContent['PRL172'] ? pageLanguageContent['PRL172'] : ''}</strong>{' '}
										{pageLanguageContent['PRL173'] ? pageLanguageContent['PRL173'] : ''} .{' '}
										{pageLanguageContent['PRL112'] ? pageLanguageContent['PRL112'] : ''}{' '}
										<strong>{pageLanguageContent['PRL172'] ? pageLanguageContent['PRL172'] : ''}</strong>{' '}
										{pageLanguageContent['PRL174'] ? pageLanguageContent['PRL174'] : ''})
									</>
								)}
							</>
						)}
					</span>
				</Col>
				<Col sm='2' className='text-right'>
					{data?.emails && !data['emails']['0']['validated'] && (
						<Badge
							bg={''}
							className='copy_content ml-1 memBadges badge badge-warning'
							onClick={() => copyContent(data['emails']['0']['code'] ? data['emails']['0']['code'] : '')}
							data-toggle='tooltip'
							title={genPageData['GENCPY'] ? genPageData['GENCPY'] : ''}
							role='button'
						>
							<i className='fas fa-copy'></i>
						</Badge>
					)}
				</Col>
			</Row>
		</fieldset>
	);
};
export default UserProfileAccountStatus;
